/* eslint-disable max-len */
import React, { useEffect, useRef, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import bannerSvg from 'assets_vacanted/banner_svg.svg';
import { Helmet } from 'react-helmet';
import textsService from '../../services/textsService';
import featureService from '../../services/featureService';
import countryService from '../../services/countryService';
import SupportLogos from '../../components/SupportLogos';
// import ExperienceSelector from '../../components/ExperienceSelector';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer';
import paths from '../../routes/paths';
import BenefitsBanner from '../Experience/src/components/benefits-banner';
import Button from '../Experience/src/components/button';
import TestimonialsCarousel from './testimonials';
import HowItWorks from './howItWorks';

import bannerImg1440 from '../../assets_vacanted/banner_home_1440.png';
import './styles.scss';

// eslint-disable-next-line no-unused-vars
const team = [
  {
    name: 'Aníbal González',
    title: 'Contador Público',
    role: 'CEO & Fundador',
    image: '/assets/img/team/anibal.jpeg',
    linkedin: 'https://www.linkedin.com/in/cranibalgonzalez/',
  },
  {
    name: 'Germán Castro',
    title: 'Ingeniero en Sistemas',
    role: 'CTO',
    image: '/assets/img/team/german.jpg',
    linkedin: 'https://www.linkedin.com/in/german-castro-86773323/',
  },
  {
    name: 'Claudia Moreno',
    title: 'Licenciada en Psicología',
    role: 'Asesora pedagógica',
    image: '/assets/img/team/claudia.jpeg',
    linkedin: 'https://www.linkedin.com/in/claudia-moreno-psic%C3%B3loga-escuela-de-padres-4aa314245/',
  },
];

const newsArticles = [
  {
    id: 'news1',
    title: '¿Cuáles son los colegios y jardines más buscados por los padres para 2025?',
    source: 'Montevideo Portal',
    date: '06/01/2025',
    image: 'https://imagenes.montevideo.com.uy/imgnoticias/202411/_W933_80/901474.jpg',
    link: 'https://www.montevideo.com.uy/Noticias/-Cuales-son-los-colegios-y-jardines-mas-buscados-por-los-padres-para-este-ano-lectivo--uc911349',
  },
  {
    id: 'news2',
    title: 'Ahora los cupos disponibles en los colegios los tenés en un solo lugar: VacantED',
    source: 'InfoNegocios',
    date: '24/03/2024',
    image: 'https://infonegocios.info/content/images/2022/07/21/117719/conversions/Vacanted-InfoNegocios-1-medium-size.jpg'
     || 'https://infonegocios.info/content/images/2022/07/22/254639/conversions/internaguiainfo-medium-size.jpg',
    link: 'https://infonegocios.biz/default/ahora-las-vacantes-de-los-colegios-las-tenes-en-un-solo-lugar',
  },
  {
    id: 'news3',
    title: 'VacantED, la startup uruguaya y su propuesta ante la crisis del sector educativo',
    source: 'El Observador',
    date: '03/01/2024',
    image: 'https://media.elobservador.com.uy/p/72a7765950d9bc8f6744f92816bd635d/adjuntos/362/imagenes/100/470/0100470294/1000x0/smart/1703941457223webp.webp'
     || 'https://www.elobservador.com.uy/css-custom/elobservador/icons/elobservador-v2.svg',
    link: 'https://www.elobservador.com.uy/nota/vacanted-una-startup-uruguaya-que-presenta-una-propuesta-ante-la-crisis-del-sector-educativo-2023123010547',
  },
  {
    id: 'news4',
    title: '¿Cuáles fueron los colegios privados más buscados por los uruguayos en 2023?',
    source: 'El Observador',
    date: '02/01/2024',
    image: 'https://www.elobservador.com.uy/css-custom/elobservador/icons/elobservador-v2.svg',
    link: 'https://www.elobservador.com.uy/nota/cuales-fueron-los-colegios-privados-mas-buscados-por-los-uruguayos-en-2023--2024125052',
  },
];

const Home = ({ defaultLoginStep }) => {
  const navigate = useNavigate();
  const shouldBeVertical = useMediaQuery({ query: '(max-width: 905px)' });
  const videoRef = useRef(null);
  const imgRef = useRef(null);

  const [openModal, setOpenModal] = useState(false);

  /* const handleSeeExperiences = async () => {
    const div = document.getElementById('experience-selector-title');
    div?.scrollIntoView({ behavior: 'smooth' });
  }; */

  const onStartSearch = () => {
    navigate(paths.NEW_EXPERIENCE);
  };

  const setVideoSource = () => {
    if (window && window.screen.width < 480) {
      videoRef.current.src = 'https://images-dev.vacanted.com.uy/media/landing/animation_360p.mp4';
    } else if (window && window.screen.width < 720) {
      videoRef.current.src = 'https://images-dev.vacanted.com.uy/media/landing/animation_480p.mp4';
    } else if (window && window.screen.width < 1080) {
      videoRef.current.src = 'https://images-dev.vacanted.com.uy/media/landing/animation_720p.mp4';
    } else if (window && window.screen.width < 1440) {
      videoRef.current.src = 'https://images-dev.vacanted.com.uy/media/landing/animation_1080p.mp4';
    } else if (window && window.screen.width >= 1440) {
      videoRef.current.src = 'https://images-dev.vacanted.com.uy/media/landing/animation_1440p.mp4';
    }
  };

  const playVideo = () => {
    videoRef.current.play = true;
    videoRef.current.loop = true;
    videoRef.current.addEventListener('loadedmetadata', () => {
      if (imgRef.current) imgRef.current.style.display = 'none';
      if (videoRef.current) videoRef.current.style.display = 'block';
    });
  };

  useEffect(() => {
    setVideoSource();
    if (videoRef.current) {
      playVideo();
    }
  }, []);

  const heroTextPart1 = textsService.getLocalizedText(textsService.TEXT_KEYS.LANDING_HERO_TITLE_1);
  const heroTextPart2 = textsService.getLocalizedText(textsService.TEXT_KEYS.LANDING_HERO_TITLE_2);
  const heroTextPart3 = textsService.getLocalizedText(textsService.TEXT_KEYS.LANDING_HERO_TITLE_3);

  return (
    <main className="home">
      <Header defaultLoginStep={defaultLoginStep} />
      <Helmet>
        <title>
          {`${heroTextPart1} ${heroTextPart2} ${heroTextPart3} - VacantED`}
        </title>
        <meta name="description" content="Te recomendamos los jardines, colegios privados, escuelas o liceos que mejor se adapten a tus preferencias y tu capacidad de pago." />
      </Helmet>
      <div className="home__video-banner">
        <div className="home__video-banner__container">
          <img className="banner-image" style={{ display: 'block' }} ref={imgRef} src={bannerImg1440} alt="" />
          <video className="banner-video" ref={videoRef} style={{ display: 'none' }} autoPlay loop muted playsInline preload="metadata" />
          <div className="banner-background" />
          <div className="banner-content">
            <h1>
              {heroTextPart1}
              {' '}
              <span>{heroTextPart2}</span>
              {' '}
              {heroTextPart3}
            </h1>
            {
              countryService.getCurrentCountryCode() === 'pe' && (
                <div className="home__video-banner__container__areas-available">
                  📍 Servicio activo en Los Olivos, Lima. ¡Muy pronto en más distritos!
                </div>
              )
            }
            <h3>
              {textsService.getLocalizedText(textsService.TEXT_KEYS.LANDING_HERO_SUBTITLE_1)}
              <br />
              <span>
                {textsService.getLocalizedText(textsService.TEXT_KEYS.LANDING_HERO_SUBTITLE_2)}
              </span>
            </h3>
            <Button hirachy="primary" size="large" onClick={onStartSearch}>
              {textsService.getLocalizedText(textsService.TEXT_KEYS.LANDING_HERO_CTA)}
            </Button>
          </div>
          {false && <img src={bannerSvg} alt="" className="banner-icon" />}
        </div>
      </div>
      {featureService.benefitsEnabled() && (
        <div className="home__section home__benefits-section">
          <div className="experience-benefits-banner-container">
            <BenefitsBanner
              openFromOutside={openModal}
              setOpenFromOutside={setOpenModal}
            />
          </div>
        </div>
      )}
      {countryService.getCurrentCountryCode() === 'uy' && <SupportLogos />}

      {/* {countryService.getCurrentCountryCode() === 'uy' && (
        <section className="home__section home__simple-section">
          <div className="home__simple-section__content vertical">
            <div className="home__simple-section__content__readable">
              <div className="home__simple-section__content__readable__text">
                <div className="home__simple-section__content__readable__text__header">
                  <span>NUESTRO EQUIPO</span>
                </div>
                <div className="home__simple-section__content__readable__text__title">
                  <span>Quiénes somos</span>
                </div>
              </div>
            </div>
            <div className="home__simple-section__content__complement">
              <div className="team-grid">
                {team.map((member) => (
                  <div key={`team-member-${member.name.toLowerCase().replace(/\s+/g, '-')}`} className="team-member">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="team-member__image"
                    />
                    <h3 className="team-member__name">{member.name}</h3>
                    <p className="team-member__title">{member.title}</p>
                    <p className="team-member__role">{member.role}</p>
                    <a
                      href={member.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="team-member__linkedin"
                      aria-label={`LinkedIn de ${member.name}`}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="#0077B5">
                        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                      </svg>
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )} */}

      {countryService.getCurrentCountryCode() === 'uy' && (
        <section className="home__section home__simple-section">
          <div className="home__simple-section__content vertical">
            <div className="home__simple-section__content__readable">
              <div className="home__simple-section__content__readable__text">
                <div className="home__simple-section__content__readable__text__header">
                  <span>PRENSA</span>
                </div>
                <div className="home__simple-section__content__readable__text__title">
                  <span>VacantED en los medios</span>
                </div>
              </div>
            </div>
            <div className="home__simple-section__content__complement">
              <div className="news-carousel">
                {newsArticles.map((article) => (
                  <a
                    key={article.id}
                    href={article.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="news-article"
                  >
                    <div className="news-article__image-container">
                      <img src={article.image} alt={article.title} className="news-article__image" />
                    </div>
                    <div className="news-article__content">
                      <h3 className="news-article__title">{article.title}</h3>
                      <div className="news-article__meta">
                        <span className="news-article__source">
                          {article.source}
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="news-article__external-link">
                            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                            <polyline points="15 3 21 3 21 9" />
                            <line x1="10" y1="14" x2="21" y2="3" />
                          </svg>
                        </span>
                        <span className="news-article__date">{article.date}</span>
                      </div>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Testimonials */}
      <section className="home__section home__simple-section">
        <div className="home__simple-section__content vertical">
          <div className="home__simple-section__content__readable">
            <div className="home__simple-section__content__readable__text">
              <div className="home__simple-section__content__readable__text__header">
                <span>TESTIMONIOS REALES</span>
              </div>
              <div className="home__simple-section__content__readable__text__title">
                <span>
                  Ayudamos a miles de familias a encontrar el mejor futuro para sus hijos.
                </span>
              </div>
            </div>
          </div>
          <div className="home__simple-section__content__complement">
            <TestimonialsCarousel />
          </div>
        </div>
      </section>

      {/* Community section */}
      {countryService.getCurrentCountryCode() === 'uy' && (
        <section className="home__section home__simple-section colored">
          <div className={`home__simple-section__content reverse ${shouldBeVertical ? 'vertical' : ''}`}>
            <div className="home__simple-section__content__readable">
              <div className="home__simple-section__content__readable__text">
                <div className="home__simple-section__content__readable__text__header">
                  <span>COMUNIDAD VACANTED URUGUAY</span>
                </div>
                <div className="home__simple-section__content__readable__text__title">
                  <span>
                    Calificá el centro de tu hijo/a y participá por un año de colegio gratis
                  </span>
                </div>
                <div className="home__simple-section__content__readable__text__subtitle">
                  <span>
                    Ayudá a miles de familias a tomar la mejor decisión educativa.
                  </span>
                </div>
              </div>
              <div className="home__simple-section__content__readable__action">
                <Button
                  hirachy="primary"
                  onClick={() => {
                    window.location.href = '/comunidad?utm_source=home';
                  }}
                >
                  Quiero participar
                </Button>
              </div>
            </div>
            <div className="home__simple-section__content__illustration">
              <div className="home__simple-section__content__illustration__wrapper" style={{ borderRadius: '1rem', overflow: 'hidden' }}>
                <img
                  className="home__simple-section__content__illustration__wrapper__image"
                  src="https://vacanted-assets-dev.s3.amazonaws.com/images/community_share3.jpg"
                  alt="Comunidad VacantED"
                  style={{ borderRadius: '1rem' }}
                />
              </div>
            </div>
          </div>
        </section>
      )}

      {/* How it works */}
      <section className="home__section home__simple-section howitworks">
        <div className="home__simple-section__content vertical">
          <div className="home__simple-section__content__readable">
            <div className="home__simple-section__content__readable__text">
              <div className="home__simple-section__content__readable__text__header">
                <span>¿CÓMO FUNCIONA?</span>
              </div>
              <div className="home__simple-section__content__readable__text__title">
                <span>
                  Tu búsqueda: fácil, ágil y personalizada
                </span>
              </div>
            </div>
          </div>
          <div className="home__simple-section__content__complement">
            <HowItWorks orientation={shouldBeVertical ? 'vertical' : 'horizontal'} />
          </div>
        </div>
      </section>

      {/* Recommendations description */}
      <section className="home__section home__simple-section">
        <div className={`home__simple-section__content ${shouldBeVertical ? 'vertical' : ''}`}>
          <div className="home__simple-section__content__readable">
            <div className="home__simple-section__content__readable__text">
              <div className="home__simple-section__content__readable__text__header">
                <span>RECOMENDACIONES PERSONALIZADAS</span>
              </div>
              <div className="home__simple-section__content__readable__text__title">
                <span>
                  {textsService.getLocalizedText(
                    textsService.TEXT_KEYS.LANDING_HOWITWORKS_RECOMMENDATIONS_TITLE,
                  )}
                </span>
              </div>
              <div className="home__simple-simple-section__content__readable__text__subtitle">
                <span>
                  {textsService.getLocalizedText(
                    textsService.TEXT_KEYS.LANDING_HOWITWORKS_RECOMMENDATIONS_SUBTITLE,
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="home__simple-section__content__illustration">
            <div className="home__simple-section__content__illustration__wrapper">
              <img
                className="home__simple-section__content__illustration__wrapper__image"
                src="https://vacanted-assets-dev.s3.amazonaws.com/images/home_recommendations.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>

      {/* Candidates and benefits description  */}
      <section className="home__section home__simple-section">
        <div className={`home__simple-section__content reverse ${shouldBeVertical ? 'vertical' : ''}`}>
          <div className="home__simple-section__content__readable">
            <div className="home__simple-section__content__readable__text">
              <div className="home__simple-section__content__readable__text__header">
                <span>GESTIONA TUS CENTROS EDUCATIVOS</span>
              </div>
              <div className="home__simple-section__content__readable__text__title">
                <span>
                  {textsService.getLocalizedText(
                    textsService.TEXT_KEYS.LANDING_HOWITWORKS_CANDIDATES_TITLE,
                  )}
                </span>
              </div>
              <div className="home__simple-section__content__readable__text__subtitle">
                <span>
                  {textsService.getLocalizedText(
                    textsService.TEXT_KEYS.LANDING_HOWITWORKS_CANDIDATES_SUBTITLE,
                  )}
                </span>
              </div>
            </div>
            {featureService.benefitsEnabled() && (
              <div className="home__simple-section__content__readable__action">
                <Button
                  hirachy="primary"
                  onClick={() => setOpenModal(true)}
                >
                  Ver beneficios
                </Button>
              </div>
            )}
          </div>
          <div className="home__simple-section__content__illustration">
            <div className="home__simple-section__content__illustration__wrapper">
              <img
                className="home__simple-section__content__illustration__wrapper__image"
                src="https://vacanted-assets-dev.s3.amazonaws.com/images/home_candidates.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>

      {/* Schools section */}
      <section className="home__section home__simple-section colored">
        <div className={`home__simple-section__content ${shouldBeVertical ? 'vertical' : ''}`}>
          <div className="home__simple-section__content__readable">
            <div className="home__simple-section__content__readable__text">
              <div className="home__simple-section__content__readable__text__header">
                <span>
                  {textsService.getLocalizedText(textsService.TEXT_KEYS.SCHOOL_LANDING_HEADER)}
                </span>
              </div>
              <div className="home__simple-section__content__readable__text__title">
                <span>
                  {textsService.getLocalizedText(textsService.TEXT_KEYS.SCHOOL_LANDING_TITLE)}
                </span>
              </div>
              <div className="home__simple-section__content__readable__text__subtitle">
                <span>
                  {textsService.getLocalizedText(textsService.TEXT_KEYS.SCHOOL_LANDING_SUBTITLE)}
                </span>
              </div>
            </div>
            <div className="home__simple-section__content__readable__action">
              <Button
                hirachy="primary"
                onClick={() => navigate('/auth/school')}
              >
                Más información
              </Button>
            </div>
          </div>
          <div className="home__simple-section__content__illustration">
            <div className="home__simple-section__content__illustration__wrapper">
              <img
                className="home__simple-section__content__illustration__wrapper__image"
                src="https://vacanted-assets-dev.s3.amazonaws.com/images/home_network.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
};

Home.propTypes = {
  defaultLoginStep: PropTypes.string,
};

Home.defaultProps = {
  defaultLoginStep: null,
};

export default Home;
